import React, { Fragment } from 'react'

import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import FooterThree from '../../../components/footer/FooterThree'

const coreValues = [
    {
        icon: 'icon-18b.svg',
        title: '\uC131\uC7A5',
        subtitle: '\uBB38\uC81C\uBCF4\uB2E4 \uD070 \uBB34\uB300\uB97C \uD568\uAED8 \uB9CC\uB4ED\uB2C8\uB2E4',
        desc: '\uCF54\uB2F4\uC5D0\uC11C\uB294 \uC131\uACFC\uAC00 \uC544\uB2CC \uC131\uC7A5 \uACFC\uC815\uC744 \uC911\uC2EC\uC73C\uB85C \uD3C9\uAC00\uD569\uB2C8\uB2E4. \uB0AE\uC120 \uBB38\uC81C\uC5D0 \uB3C4\uC804\uD558\uACE0 \uB2F5\uC744 \uB9CC\uB4E4\uC5B4\uAC00\uB294 \uD798\uC774 \uAC1C\uC778\uACFC \uD300\uC744 \uD06C\uAC8C \uD0A4\uC6C1\uB2C8\uB2E4.',
        tags: ['\uD559\uC2B5 \uBB38\uD654', '\uC2A4\uD130\uB514 \uBB38\uD654', '\uCE90\uB9AC\uC5B4 \uC131\uC7A5']
    },
    {
        icon: 'icon-19b.svg',
        title: '\uC2E0\uB8B0',
        subtitle: '\uD22C\uBA85\uD55C \uB300\uD654\uAC00 \uC2E4\uD589\uB825\uC744 \uB9CC\uB4ED\uB2C8\uB2E4',
        desc: '\uC2E0\uB8B0\uB294 \uD55C\uBC88\uC758 \uC120\uC5B8\uC774 \uC544\uB2C8\uB77C \uB9E4\uC77C\uC758 \uD0DC\uB3C4\uB85C \uC313\uC785\uB2C8\uB2E4. \uCF54\uB2F4\uC740 \uBB38\uC81C\uB97C \uC228\uAE30\uC9C0 \uC54A\uACE0, \uC0AC\uC2E4\uACFC \uB370\uC774\uD130\uB97C \uACF5\uC720\uD558\uBA70 \uD568\uAED8 \uD574\uACB0\uCC45\uC744 \uCC3E\uC2B5\uB2C8\uB2E4.',
        tags: ['\uC218\uD3C9\uC18C\uD1B5', '\uC2E4\uD589\uD611\uC5C5', '\uD22C\uBA85\uACBD\uC601']
    },
    {
        icon: 'icon-15b.svg',
        title: '\uD601\uC2E0',
        subtitle: '\uB354 \uB098\uC740 \uBC29\uC2DD\uC744 \uC9C0\uAE08 \uB2F9\uC7A5 \uC2E4\uD589\uD569\uB2C8\uB2E4',
        desc: '\uD601\uC2E0\uC740 \uD2B9\uBCC4\uD55C \uC21C\uAC04\uC5D0\uC11C\uB9CC \uBC1C\uC0DD\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uAE30\uC874 \uBC29\uC2DD\uC744 \uC2E0\uD0C0\uD30C\uD558\uACE0 \uC791\uAC8C \uBE60\uB974\uAC8C \uC2E4\uD5D8\uD558\uBA70, \uAC1C\uC120 \uC0AC\uC774\uD074\uC744 \uB193\uCE58\uC9C0 \uC54A\uB294 \uAC83\uC774 \uCF54\uB2F4\uC758 \uC2E4\uD589 \uD601\uC2E0\uC785\uB2C8\uB2E4.',
        tags: ['\uBE60\uB978 \uC2E4\uD589', '\uC2E4\uD5D8 \uBB38\uD654', '\uC9C0\uC18D \uAC1C\uC120']
    },
    {
        icon: 'icon-16b.svg',
        title: '\uC5F0\uACB0',
        subtitle: '\uAE30\uC220\uC740 \uD56D\uC0C1 \uC0AC\uB78C\uC73C\uB85C \uC644\uC131\uB429\uB2C8\uB2E4',
        desc: '\uCF54\uB2F4\uC740 \uAE30\uC220 \uC790\uCCB4\uBCF4\uB2E4 \uAE30\uC220\uC774 \uB9CC\uB4DC\uB294 \uACBD\uD5D8\uACFC \uBCC0\uD654\uB97C \uB354 \uC911\uC694\uD558\uAC8C \uBC15\uB2C8\uB2E4. \uC0AC\uC6A9\uC790\uC640 \uD604\uC7A5, \uB370\uC774\uD130\uC640 \uC758\uC0AC\uACB0\uC815, \uC11C\uBE44\uC2A4\uC640 \uC131\uACFC\uB97C \uC5F0\uACB0\uD558\uC5EC \uC2E4\uC9C8\uC801 \uAC00\uCE58\uB97C \uB9CC\uB4ED\uB2C8\uB2E4.',
        tags: ['\uC0AC\uC6A9\uC790 \uC911\uC2EC', '\uC0AC\uB78C \uC911\uC2EC', '\uD611\uC5C5']
    },
    {
        icon: 'icon-17b.svg',
        title: '\uB2E4\uC591\uC131',
        subtitle: '\uB2E4\uB978 \uC2DC\uC120\uC774 \uB354 \uC88B\uC740 \uD574\uACB0\uC744 \uB9CC\uB4ED\uB2C8\uB2E4',
        desc: '\uBE44\uC2B7\uD55C \uC0AC\uB78C\uB4E4\uC774 \uBAA8\uC774\uBA74 \uBE44\uC2B7\uD55C \uB2F5\uC5D0 \uBA38\uBB34\uB97C \uAC00\uB2A5\uC131\uC774 \uD07D\uB2C8\uB2E4. \uCF54\uB2F4\uC740 \uBC30\uACBD\u00B7\uACBD\uB825\u00B7\uAD00\uC810\uC758 \uB2E4\uC591\uC131\uC744 \uC874\uC911\uD558\uACE0, \uCC28\uC774\uB97C \uD611\uC5C5\uC758 \uB3D9\uB825\uC73C\uB85C \uC0BC\uC2B5\uB2C8\uB2E4.',
        tags: ['\uD3EC\uC6A9\uC801 \uBB38\uD654', '\uB2E4\uC591\uD55C \uAD00\uC810', '\uCC3D\uC758\uC801 \uBB38\uC81C\uD574\uACB0']
    },
    {
        icon: 'icon-20b.svg',
        title: '\uC9C0\uC18D\uAC00\uB2A5\uC131',
        subtitle: '\uC624\uB798 \uAC00\uB294 \uAC00\uCE58\uB97C \uB9CC\uB4DC\uB294 \uC120\uD0DD\uC744 \uD569\uB2C8\uB2E4',
        desc: '\uB2E8\uAE30 \uC131\uACFC\uBCF4\uB2E4 \uC7A5\uAE30 \uC784\uD329\uD2B8\uAC00 \uC911\uC694\uD569\uB2C8\uB2E4. \uCF54\uB2F4\uC740 \uAD6C\uC870\uC640 \uC2A4\uD0DD, \uC6B4\uC601 \uBC29\uC2DD\uAE4C\uC9C0 \uC624\uB798 \uC720\uC9C0\uB418\uACE0 \uD655\uC7A5\uAC00\uB2A5\uD55C \uC120\uD0DD\uC744 \uD558\uBA70, \uC0AC\uD68C\uC640 \uD658\uACBD\uC5D0 \uB300\uD55C \uCC45\uC784\uC744 \uD568\uAED8 \uACE0\uB824\uD569\uB2C8\uB2E4.',
        tags: ['\uC7A5\uAE30 \uAC00\uCE58', '\uCC45\uC784 \uC6B4\uC601', 'ESG']
    }
]

const CoreValues = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                <ThemeMenuThree />
                <PageTitle title="핵심 가치" />

                <section id="codam-core-values" className="counter-area codam-core-values pt-120 pb-110 pt-lg-70 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-12">
                                <div className="section-title-two text-center mb-45">
                                    <h6 className="sub-title mb-20">코담 가치 체계</h6>
                                    <h2 className="sect-title">{'\uCF54\uB2F4\uC758 \uD575\uC2EC \uAC00\uCE58'}</h2>
                                    <p className="mt-20 mb-0">
                                        {'\uCF54\uB2F4\uC740 \uC0AC\uB78C\uC744 \uC911\uC2EC\uC5D0 \uB454 \uAC00\uCE58\uB97C \uBC14\uD0D5\uC73C\uB85C \uC9C0\uC18D \uAC00\uB2A5\uD55C \uC131\uC7A5\uC744 \uB9CC\uB4ED\uB2C8\uB2E4.'}
                                    </p>
                                </div>
                            </div>
                            {coreValues.map((item) => (
                                <div key={item.title} className="col-md-6 col-xl-4 mb-35">
                                    <div className="feature-style-one h-100 mb-0">
                                        <span className="top-arrow" aria-hidden="true"><i className="bi bi-arrow-up-right" /></span>
                                        <img className="front-icon" src={`assets/img/icon/${item.icon}`} alt="" />
                                        <h2>{item.title}</h2>
                                        <h5 className="mb-15 codam-core-values__subtitle">{item.subtitle}</h5>
                                        <p>{item.desc}</p>
                                        <div className="d-flex flex-wrap gap-2 codam-core-values__tags">
                                            {item.tags.map((tag) => (
                                                <span key={tag} className="badge bg-light text-dark">{tag}</span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <FooterThree hideNewsletter />
            </div>
        </Fragment>
    )
}

export default CoreValues
